export const locales = {
  RU: 'ru',
}
